import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useSEO } from '../../utils/seo';

const WorksPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('すべて');

  // SEO設定
  useSEO({
    title: '岡山市の解体工事・造園工事の施工実績｜おかやま解体工事株式会社',
    description: '岡山市での建物解体工事、内装解体工事、造園工事、外構工事、不用品処理の施工事例を写真付きでご紹介。500件以上の実績と信頼。施工前・施工後の比較でわかりやすく掲載。',
    keywords: '岡山市,施工実績,解体工事,造園工事,施工事例,ビフォーアフター,岡山',
    canonicalPath: '/works',
    structuredData: {
      '@context': 'https://schema.org',
      '@type': 'CollectionPage',
      name: '施工実績',
      description: '岡山市での解体工事・造園工事の施工事例集',
      provider: {
        '@type': 'LocalBusiness',
        name: 'おかやま解体工事株式会社'
      }
    }
  });

  const categories = ['すべて', '建物解体', '内装解体', '造園工事', '外構工事', '不用品処理'];

  const works = [
    {
      title: '岡山市北区 木造住宅解体工事',
      location: '岡山市北区',
      duration: '5日間',
      category: '建物解体',
      description: '築50年の木造住宅を安全かつ迅速に解体。近隣への配慮を徹底し、騒音・粉塵対策を万全に実施しました。お客様からも高い評価をいただきました。',
      beforeImage: 'https://public.readdy.ai/ai/img_res/d872eb9180d3c5296e873d632a2bcdb8.jpg',
      afterImage: 'https://readdy.ai/api/search-image?query=cleared%20empty%20land%20plot%20after%20house%20demolition%20in%20Okayama%20city%2C%20clean%20leveled%20ground%20ready%20for%20new%20construction%2C%20simple%20background%2C%20bright%20daylight%2C%20professional%20site%20preparation%20result&width=600&height=700&seq=works1after&orientation=portrait',
    },
    {
      title: '岡山市中区 店舗内装解体',
      location: '岡山市中区',
      duration: '3日間',
      category: '内装解体',
      description: '飲食店の原状回復工事。スケルトン状態まで解体し、オーナー様にご満足いただきました。短期間での施工を実現しました。',
      beforeImage: 'https://readdy.ai/api/search-image?query=empty%20Japanese%20restaurant%20interior%20space%20before%20demolition%20with%20commercial%20kitchen%20equipment%20counter%20tables%20and%20fixtures%20still%20installed%2C%20worn%20flooring%20and%20walls%20showing%20age%2C%20commercial%20lighting%20visible%2C%20realistic%20documentation%20style%20photography%20in%20Okayama&width=500&height=600&seq=work6before-updated&orientation=portrait',
      afterImage: 'https://readdy.ai/api/search-image?query=completely%20cleared%20commercial%20space%20after%20interior%20demolition%20showing%20bare%20concrete%20walls%20floors%20and%20exposed%20ceiling%20in%20skeleton%20condition%2C%20clean%20empty%20room%20ready%20for%20renovation%2C%20bright%20lighting%2C%20professional%20restoration%20documentation%20in%20Okayama&width=500&height=600&seq=work6after&orientation=portrait',
    },
    {
      title: '岡山市南区 庭園リニューアル',
      location: '岡山市南区',
      duration: '7日間',
      category: '造園工事',
      description: '荒れた庭を美しい和風庭園に生まれ変わらせました。石組みと植栽のバランスにこだわり、お客様の理想を実現しました。',
      beforeImage: 'https://readdy.ai/api/search-image?query=overgrown%20neglected%20Japanese%20garden%20before%20renovation%20with%20weeds%20and%20untended%20plants%2C%20residential%20property%20in%20Okayama%2C%20simple%20clean%20background%2C%20natural%20outdoor%20setting&width=600&height=700&seq=works3before&orientation=portrait',
      afterImage: 'https://readdy.ai/api/search-image?query=beautifully%20renovated%20Japanese%20garden%20with%20carefully%20arranged%20stones%20and%20fresh%20plantings%2C%20peaceful%20zen%20atmosphere%2C%20clean%20simple%20background%2C%20professional%20landscaping%20result%20in%20Okayama%20residential%20area&width=600&height=700&seq=works3after&orientation=portrait',
    },
    {
      title: '岡山市東区 鉄骨造ビル解体',
      location: '岡山市東区',
      duration: '10日間',
      category: '建物解体',
      description: '3階建て鉄骨造ビルの解体工事。大型重機を使用し、安全管理を徹底しながら計画通りに完了しました。',
      beforeImage: 'https://readdy.ai/api/search-image?query=old%20three-story%20steel%20frame%20building%20before%20demolition%20in%20Okayama%20city%2C%20commercial%20structure%20showing%20age%2C%20simple%20clean%20background%2C%20daytime%20architectural%20documentation&width=600&height=700&seq=works4before&orientation=portrait',
      afterImage: 'https://readdy.ai/api/search-image?query=cleared%20commercial%20land%20after%20steel%20building%20demolition%20in%20Okayama%2C%20flat%20prepared%20ground%20for%20redevelopment%2C%20simple%20background%2C%20professional%20demolition%20completion&width=600&height=700&seq=works4after&orientation=portrait',
    },
    {
      title: '岡山市北区 オフィス原状回復',
      location: '岡山市北区',
      duration: '4日間',
      category: '内装解体',
      description: 'オフィスビルのワンフロア原状回復工事。パーテーション撤去から床・壁の補修まで一貫して対応しました。',
      beforeImage: 'https://readdy.ai/api/search-image?query=office%20space%20with%20partitions%20and%20furniture%20before%20restoration%20work%20in%20Okayama%2C%20commercial%20interior%20with%20cubicles%2C%20simple%20clean%20background%2C%20professional%20documentation&width=600&height=700&seq=works5before&orientation=portrait',
      afterImage: 'https://readdy.ai/api/search-image?query=restored%20empty%20office%20floor%20after%20partition%20removal%20in%20Okayama%2C%20clean%20open%20space%20ready%20for%20new%20tenant%2C%20simple%20background%2C%20professional%20restoration%20completion&width=600&height=700&seq=works5after&orientation=portrait',
    },
    {
      title: '岡山市中区 外構フェンス設置',
      location: '岡山市中区',
      duration: '6日間',
      category: '外構工事',
      description: '住宅の外構工事。デザイン性と機能性を兼ね備えたフェンスと門扉を設置し、住まいの価値を高めました。',
      beforeImage: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/df55f0dad113f73c4e8f6e704bde2733.jpeg',
      afterImage: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/649c31f877c65e5839d1f599cc2a7e6b.png',
    },
    {
      title: '岡山市南区 ゴミ屋敷片付け',
      location: '岡山市南区',
      duration: '2日間',
      category: '不用品処理',
      description: '大量の不用品が溜まった住宅の片付け。丁寧に分別し、適切に処理。お客様のプライバシーにも配慮しました。',
      beforeImage: 'https://readdy.ai/api/search-image?query=cluttered%20Japanese%20house%20interior%20filled%20with%20items%20before%20cleanup%20in%20Okayama%2C%20residential%20space%20needing%20organization%2C%20simple%20clean%20background%2C%20respectful%20documentation&width=600&height=700&seq=works7before&orientation=portrait',
      afterImage: 'https://readdy.ai/api/search-image?query=clean%20empty%20Japanese%20house%20interior%20after%20thorough%20cleanup%20in%20Okayama%2C%20organized%20living%20space%20restored%2C%20simple%20background%2C%20professional%20cleaning%20result&width=600&height=700&seq=works7after&orientation=portrait',
    },
    {
      title: '岡山市東区 駐車場舗装工事',
      location: '岡山市東区',
      duration: '5日間',
      category: '外構工事',
      description: '住宅の駐車場舗装工事。耐久性の高いアスファルト舗装で、長期間美しさを保てる仕上がりになりました。',
      beforeImage: 'https://readdy.ai/api/search-image?query=unpaved%20dirt%20parking%20area%20before%20construction%20at%20Japanese%20residence%20in%20Okayama%2C%20rough%20ground%20surface%2C%20simple%20clean%20background%2C%20daytime%20photography&width=600&height=700&seq=works8before&orientation=portrait',
      afterImage: 'https://readdy.ai/api/search-image?query=newly%20paved%20asphalt%20parking%20area%20at%20Japanese%20residence%20in%20Okayama%2C%20smooth%20professional%20surface%20completed%2C%20simple%20background%2C%20quality%20construction%20result&width=600&height=700&seq=works8after&orientation=portrait',
    },
    {
      title: '岡山市北区 和風庭園造成',
      location: '岡山市北区',
      duration: '8日間',
      category: '造園工事',
      description: '新築住宅の和風庭園造成。灯籠や飛び石を配置し、四季を感じられる美しい庭園を創り上げました。',
      beforeImage: 'https://readdy.ai/api/search-image?query=empty%20yard%20space%20before%20Japanese%20garden%20construction%20in%20Okayama%2C%20bare%20ground%20at%20new%20residence%2C%20simple%20clean%20background%2C%20natural%20outdoor%20setting&width=600&height=700&seq=works9before&orientation=portrait',
      afterImage: 'https://readdy.ai/api/search-image?query=completed%20traditional%20Japanese%20garden%20with%20stone%20lantern%20and%20stepping%20stones%20in%20Okayama%2C%20beautiful%20zen%20garden%20design%2C%20simple%20background%2C%20professional%20landscaping%20achievement&width=600&height=700&seq=works9after&orientation=portrait',
    },
  ];

  const filteredWorks = selectedCategory === 'すべて' 
    ? works 
    : works.filter(work => work.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative h-[50vh] min-h-[300px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/d395453c5ed7aa31e9828d218b21d62c.jpeg"
            alt="施工実績"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>

        <div className="relative z-10 container mx-auto px-4 lg:px-8 text-center">
          <div className="inline-flex items-center space-x-4 bg-white/20 backdrop-blur-sm px-6 py-3 rounded-full mb-6">
            <i className="ri-gallery-line text-white w-5 h-5 flex items-center justify-center"></i>
            <span className="text-sm font-medium text-white">500件以上の実績</span>
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
            施工実績
          </h1>
          <p className="text-lg md:text-xl text-white/90 max-w-3xl mx-auto">
            実際の施工事例をご覧ください
          </p>
        </div>
      </section>

      {/* Filter Bar */}
      <section className="py-8 bg-white border-b border-gray-200">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="flex flex-col lg:flex-row items-start lg:items-center gap-4">
            <span className="text-gray-600 font-medium whitespace-nowrap">カテゴリーで絞り込み</span>
            <div className="flex flex-wrap gap-3">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-6 py-2.5 rounded-full border-2 transition-all whitespace-nowrap cursor-pointer ${
                    selectedCategory === category
                      ? 'bg-primary text-white border-primary'
                      : 'bg-white text-primary border-gray-300 hover:border-primary'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Works Grid */}
      <section className="py-16 lg:py-24 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredWorks.map((work, index) => (
              <article key={index} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-shadow cursor-pointer flex flex-col">
                <div className="grid grid-cols-2 h-72 flex-shrink-0">
                  <div className="relative">
                    <img
                      src={work.beforeImage}
                      alt={`${work.title} 施工前`}
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute top-2 left-2 bg-black/70 text-white px-3 py-1 rounded text-xs">
                      施工前
                    </div>
                  </div>
                  <div className="relative">
                    <img
                      src={work.afterImage}
                      alt={`${work.title} 施工後`}
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute top-2 right-2 bg-secondary text-white px-3 py-1 rounded text-xs">
                      施工後
                    </div>
                  </div>
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <h3 className="text-primary font-bold text-lg sm:text-xl mb-3 break-words">{work.title}</h3>
                  <div className="flex items-center text-gray-600 text-sm mb-2">
                    <i className="ri-map-pin-line mr-2 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                    <span>{work.location}</span>
                  </div>
                  <div className="flex items-center text-gray-600 text-sm mb-4">
                    <i className="ri-time-line mr-2 w-4 h-4 flex items-center justify-center flex-shrink-0"></i>
                    <span>{work.duration}</span>
                  </div>
                  <p className="text-gray-700 text-sm leading-relaxed mb-4 flex-1">{work.description}</p>
                  <Link to="/contact" className="text-primary underline hover:text-secondary transition-colors cursor-pointer">
                    詳細を見る
                  </Link>
                </div>
              </article>
            ))}
          </div>

          {/* Pagination */}
          <div className="flex justify-center items-center space-x-2 mt-12">
            <button className="w-10 h-10 rounded-full bg-primary text-white flex items-center justify-center hover:bg-secondary transition-all cursor-pointer">
              1
            </button>
            <button className="w-10 h-10 rounded-full bg-white text-primary border border-gray-300 flex items-center justify-center hover:bg-gray-100 transition-all cursor-pointer">
              2
            </button>
            <button className="w-10 h-10 rounded-full bg-white text-primary border border-gray-300 flex items-center justify-center hover:bg-gray-100 transition-all cursor-pointer">
              3
            </button>
            <span className="text-gray-500">...</span>
            <button className="px-4 h-10 rounded-full bg-white text-primary border border-gray-300 flex items-center justify-center hover:bg-gray-100 transition-all whitespace-nowrap cursor-pointer">
              次へ
            </button>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative h-[600px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=wide%20panoramic%20view%20of%20beautiful%20Okayama%20cityscape%20with%20construction%20site%20in%20foreground%2C%20professional%20Japanese%20workers%20visible%20in%20distance%2C%20bright%20sunny%20day%20with%20clear%20sky%2C%20clean%20organized%20work%20environment%2C%20inspiring%20and%20professional%20atmosphere&width=1920&height=1080&seq=works-cta&orientation=landscape"
            alt="岡山の風景"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        <div className="relative z-10 container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight">
              まずはお気軽に<br />ご相談ください
            </h2>
          </div>
          <div className="absolute bottom-12 right-8 text-right">
            <p className="text-white text-xl lg:text-2xl font-light mb-4">
              無料見積もり・現地調査実施中
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-end">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center px-8 py-4 bg-white text-primary rounded-full hover:bg-gray-100 transition-all font-medium whitespace-nowrap cursor-pointer"
              >
                お問い合わせ
              </Link>
              <a
                href="tel:086-012-3456"
                className="inline-flex items-center justify-center px-8 py-4 bg-secondary text-white rounded-full hover:bg-primary transition-all font-medium whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                086-012-3456
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default WorksPage;
